import React, { useState } from "react";
import { config } from "../config/config";
import MateriaForm from "../components/MateriaForm";
import MateriaList from "../components/MateriaList";
import showAlert from "../components/Alert";
import showConfirm from "../components/ConfirmAlert";

const Materias = () => {
    const [editingMateria, setEditingMateria] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false); // Estado para gestionar la recarga
    const [resetForm, setResetForm] = useState(false);

    const reloadMateriaList = () => {
        setReloadTrigger(!reloadTrigger); // Cambiar el valor para activar la recarga
    };

    const handleCreateOrUpdate = (materia) => {
        const url = editingMateria
            ? `${config.apiUrl}/materias/${editingMateria.materia_id}`
            : `${config.apiUrl}/materias`;
        const method = editingMateria ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(materia),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Error al guardar la información");
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingMateria);
                setEditingMateria(null);
                setResetForm(true);
                reloadMateriaList(); // Recargar la lista después de guardar
            })
            .catch(console.error);
    };

    const handleDelete = async (id) => {
        const isConfirmed = await showConfirm();
        if (isConfirmed) {
            fetch(`${config.apiUrl}/materias/${id}`, { method: "DELETE" })
                .then(() => {
                    console.log("Materia eliminada");
                    reloadMateriaList(); // Recargar la lista después de eliminar
                })
                .catch(console.error);
        }
    };

    return (
        <div>
            <MateriaForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingMateria}
                resetForm={resetForm}
            />
            <MateriaList
                onEdit={(materia) => setEditingMateria(materia)}
                onDelete={handleDelete}
                reloadTrigger={reloadTrigger} // Pasamos reloadTrigger a MateriaList
            />
        </div>
    );
};

export default Materias;